"use strict";

var LoggerInstance = require("js-logger").get("MySubscriptionsHelper");

var AccountStore = require("./AccountStore");
var AccountFormHelper = require("./AccountFormHelper");
var MySubscriptionsRefresh = require("./MySubscriptionsRefresh");

var ActionsHelper = require("../actions/ActionsHelper");

var AccountApi = require("../api/AccountApi");
var SavedPaymentsApi = require("../api/SavedPaymentsApi");

var Spinner = require("../client/Spinner");

var PaymentHelper = require("../commonComponents/PaymentHelper");
var SubmitButtonHelper = require("../commonComponents/SubmitButtonHelper");
var ValidationHelper = require("../commonComponents/ValidationHelper");

var {
	BILLING_ADDRESS_SELECTION_TYPES: BillingAddressSelectionTypes,
	PAYMENT_TERMS_TYPES: PaymentTermsTypes
} = require("../designer/Constants");

var ApiHelper = require("../shared/ApiHelper");
var LinkMessageHelper = require("../shared/LinkMessageHelper");
var PartialResponseHelper = require("../shared/PartialResponseHelper");

var MySubscriptionsHelper = {
	cancelMagazineEmailSubscriptionEdit(event) {
		event = this._getEventOrReturn(event, LinkMessageHelper.linkMessageMapper("magazineEmailSubscriptionCancelEdit"));
		if (!event) {
			return false;
		}

		this.toggleEditSubscription(event, /* type */ "email", /* isEditing */ false);
		return false;
	},

	cancelMagazineMailSubscriptionEdit(event) {
		event = this._getEventOrReturn(event, LinkMessageHelper.linkMessageMapper("magazineMailSubscriptionCancelEdit"));
		if (!event) {
			return false;
		}

		this.toggleEditSubscription(event, /* type */ "mail", /* isEditing */ false);
		return false;
	},

	cancelMembershipSubscriptionEdit(event) {
		event = this._getEventOrReturn(event, LinkMessageHelper.linkMessageMapper("membershipSubscriptionCancelEdit"));
		if (!event) {
			return false;
		}

		this.toggleEditSubscription(event, /* type */ "membership", /* isEditing */ false);
		return false;
	},

	cancelProductSubscriptionEdit(event) {
		event = this._getEventOrReturn(event, LinkMessageHelper.linkMessageMapper("productSubscriptionCancelEdit"));
		if (!event) {
			return false;
		}

		this.toggleEditSubscription(event, /* type */ "product", /* isEditing */ false);
		return false;
	},

	editMagazineEmailSubscription(event) {
		event = this._getEventOrReturn(event, LinkMessageHelper.linkMessageMapper("magazineEmailSubscriptionEdit"));
		if (!event) {
			return false;
		}

		this.toggleEditSubscription(event, /* type */ "email", /* isEditing */ true);
		return false;
	},

	editMagazineMailSubscription(event) {
		event = this._getEventOrReturn(event, LinkMessageHelper.linkMessageMapper("magazineMailSubscriptionEdit"));
		if (!event) {
			return false;
		}

		this.toggleEditSubscription(event, /* type */ "mail", /* isEditing */ true);
		return false;
	},

	editMembershipSubscription(event) {
		event = this._getEventOrReturn(event, LinkMessageHelper.linkMessageMapper("membershipSubscriptionEdit"));
		if (!event) {
			return false;
		}

		this.toggleEditSubscription(event, /* type */ "membership", /* isEditing */ true);
		return false;
	},

	editProductSubscription(event) {
		event = this._getEventOrReturn(event, LinkMessageHelper.linkMessageMapper("productSubscriptionEdit"));
		if (!event) {
			return false;
		}

		this.toggleEditSubscription(event, /* type */ "product", /* isEditing */ true);
		return false;
	},

	initialize: function (options) {
		options = options || {};

		this.accountData = options.accountData;

		if (!options.isDesignMode) {
			MySubscriptionsRefresh.initializeEditLinks();
			MySubscriptionsRefresh.initializeRenewLinks();
		}
	},

	processSubscriptionUpdate(type, event) {
		event = this._getEventOrReturn(event, "Update Subscription called successfully.");
		if (!event) {
			return null;
		}

		var editComponentSelector = MySubscriptionsRefresh.getEditSelector(type);

		var $updateForm = $(event.target).closest("form");
		var $editComponent = $updateForm.closest(editComponentSelector);
		var $autoRenewCheckbox = $editComponent.find("[data-component='autoRenewCheckbox'] input");
		var $editPaymentCheckbox = $editComponent.find("[data-component='editPaymentCheckbox'] input");

		var subscription = JSON.parse($editComponent.attr("data-subscription"));

		var paymentTermsText =
			subscription &&
			subscription.subscriptionDisplayObject &&
			subscription.subscriptionDisplayObject.PaymentTermsText;

		// get autoRenew checkbox value
		var isAutoRenewCheckboxValue = $autoRenewCheckbox.length ? $autoRenewCheckbox.prop("checked") === true : null;
		var isAutoRenew = isAutoRenewCheckboxValue === null ? subscription.autoRenew : isAutoRenewCheckboxValue;
		var isEditPayment = $editPaymentCheckbox.prop("checked") === true;

		var components = [
			$editComponent
		];

		Spinner.showSpinner($editComponent);
		ValidationHelper.validate({ components }).always(isValid => {
			if (!isValid) {
				Spinner.removeSpinner($editComponent);
				return;
			}

			this._shouldShowPaymentTerms(isAutoRenew, isEditPayment, paymentTermsText)
				.done((shouldShowPaymentTerms) => {
					if (shouldShowPaymentTerms) {
						var deferred = new $.Deferred();

						// Hide the edit component-level spinner and show a full-page spinner instead
						Spinner.showSpinner();
						Spinner.removeSpinner($editComponent);

						PaymentTermsHelper.showPaymentTermsModal(deferred, { PaymentTermsText: paymentTermsText }, PaymentTermsTypes.MY_SUBSCRIPTIONS);
						deferred.done((doesAgreeToTerms) => {
							if (doesAgreeToTerms) {
								// Hide the full-page spinner and show the edit component-level spinner again
								Spinner.removeSpinner();
								Spinner.showSpinner($editComponent);

								this._updateSubscription(type, editComponentSelector, $editComponent, isAutoRenewCheckboxValue, isAutoRenew, isEditPayment, paymentTermsText);
							} else {
								Spinner.removeSpinner();
							}
						}).fail(() => {
							Spinner.removeSpinner();
						});
					} else {
						// Not showing payment terms
						this._updateSubscription(type, editComponentSelector, $editComponent, isAutoRenewCheckboxValue, isAutoRenew, isEditPayment);
					}
				})
				.fail(() => {
					LoggerInstance.warn("An error occurred while checking to see if payment terms should be shown. Continuing to update subscription.");
					this._updateSubscription(type, editComponentSelector, $editComponent, isAutoRenewCheckboxValue, isAutoRenew, isEditPayment);
				});
		});

		return false;
	},

	_updateSubscription(type, editComponentSelector, $editComponent, isAutoRenewCheckboxValue, isAutoRenew, isEditPayment, acceptedPaymentTermsText) {
		var $singleSubscriptionComponent = $editComponent.closest(MySubscriptionsRefresh.getSinglePopulatedSelector(type));
		var subscriptionId = $singleSubscriptionComponent.attr("data-subscription-id");

		// get account form data
		var $editAccountForm = $editComponent.find("[data-component='createAccountForm']");
		var accountData = AccountFormHelper.serializeCreateAccountFormOnly({
			accountFormId: $editAccountForm.attr("id")
		});

		// update the payment information otherwise, just update the subscription
		// payment information only needs to be updated if we are autoRenew as well
		if (isEditPayment && isAutoRenew) {
			// process payment information
			PaymentHelper.getPaymentData(
				AccountStore.get("wizardCompanyErrorMessages"),
				AccountStore.get("wizardCompanyEftErrorMessages"),
				(hostedPageTokenObject) => {
					var isNewBillingAddress = hostedPageTokenObject.billingAddressInformation &&
						hostedPageTokenObject.billingAddressInformation.selectionType === BillingAddressSelectionTypes.NEW;

					var saveEditedPayment = () => {
						// send token to API
						SavedPaymentsApi.addSavedPaymentToAccount({
							companyCode: AccountStore.get("companyCode"),
							isPrimary: false, // This payment should always be a non-primary payment
							payment: hostedPageTokenObject
						}).done((paymentResponse) => {
							// make call to update the subscription once we have all data
							AccountApi.mySubscriptionsEdit(
								subscriptionId,
								type,
								{
									accountData,
									isAutoRenew: isAutoRenewCheckboxValue,
									savedPaymentId: paymentResponse.id,
									acceptedPaymentTermsText
								},
								$editComponent
									.closest(MySubscriptionsRefresh.getSubscriptionSelector(type))
									.attr("id")
							).done((data) => {
								this._updateSuccess(data, editComponentSelector, $singleSubscriptionComponent, isNewBillingAddress);
							}).fail((jqXHR, textStatus) => {
								LoggerInstance.error("Unable to save subscription");
								this._resolveError(jqXHR, textStatus);
								Spinner.removeSpinner($editComponent);
							});
						}).fail((jqXHR, textStatus) => {
							LoggerInstance.error("Unable to process payment");
							this._resolveError(jqXHR, textStatus, /*deferred*/null, AccountStore.get("wizardSavedPaymentsDisplayMessages").savedPaymentForSubscriptionError);
							Spinner.removeSpinner($editComponent);
						});
					}

					if (isNewBillingAddress) {
						SmartyStreets.verifyAddress(`subscriptionBillingAddressesAdd-${subscriptionId}`)
							.done(() => {
								saveEditedPayment();
							})
							.fail(() => Spinner.removeSpinner($editComponent));
					} else {
						saveEditedPayment();
					}
				},
				(hasAlerted) => { //errorCallback
					LoggerInstance.error("Error getting payment data");
					if (!hasAlerted) {
						ApiHelper.displayErrorMessage();
					}
					Spinner.removeSpinner($editComponent);
				},
				$editComponent
			);
		} else {
			AccountApi.mySubscriptionsEdit(
				subscriptionId,
				type,
				{
					accountData,
					isAutoRenew: isAutoRenewCheckboxValue,
					acceptedPaymentTermsText
				},
				$editComponent
					.closest(MySubscriptionsRefresh.getSubscriptionSelector(type))
					.attr("id")
			).done((data) => {
				this._updateSuccess(data, editComponentSelector, $singleSubscriptionComponent);
			}).fail((jqXHR, textStatus) => {
				LoggerInstance.error("Unable to save subscription");
				this._resolveError(jqXHR, textStatus);
				Spinner.removeSpinner($editComponent);
			});
		}
	},

	_shouldShowPaymentTerms(isAutoRenew, isEditPayment, paymentTermsText) {
		var deferred = new $.Deferred();

		if (!paymentTermsText) {
			deferred.resolve(false);
			return deferred;
		}

		if (!isAutoRenew || !isEditPayment) {
			deferred.resolve(false);
			return deferred;
		}

		PaymentTermsHelper.arePaymentTermsConfigured()
			.done(arePaymentTermsConfigured => deferred.resolve(arePaymentTermsConfigured))
			.fail(() => deferred.resolve(false));

		return deferred;
	},

	toggleEditSubscription(event, type, isEditing) {
		var $component = isEditing
			? $(event.target).closest(MySubscriptionsRefresh.getViewSelector(type))
			: $(event.target).closest(MySubscriptionsRefresh.getEditSelector(type));

		Spinner.showSpinner($component);

		MySubscriptionsRefresh
			.getMySubscriptionsHtml(
				event,
				type,
				isEditing,
				this.accountData,
				this.processSubscriptionUpdate.bind(this, type))
			.always(() => Spinner.removeSpinner($component));
	},

	_getEventOrReturn: function (event, isDesignModeMessage) {
		return ActionsHelper.getEventOrReturn(event, AccountStore.get("isDesignMode"), isDesignModeMessage, /*preventDefaultInDesignMode*/false);
	},

	_resolveError(jqXHR, textStatus, deferred, errorMessage) {
		if (!jqXHR || !jqXHR.responseJSON || !PartialResponseHelper.handleErrorResponse(jqXHR.responseJSON)) {
			//There was not a partial error, so do what we normally would do.
			ApiHelper.displayErrorMessage(jqXHR, errorMessage);
		}

		if (deferred) {
			deferred.reject(jqXHR, textStatus);
		}
	},

	_updateSuccess(data, editComponentSelector, $singleSubscriptionComponent, shouldReloadPage) {
		var postSubmitActionData = SubmitButtonHelper.getPostSubmitActionData(editComponentSelector);

		if (!shouldReloadPage) {
			// write the response (edit component partial) back into the DOM
			$singleSubscriptionComponent.html(data);
			MySubscriptionsRefresh.initializeEditLinks($singleSubscriptionComponent);
			MySubscriptionsRefresh.initializeRenewLinks($singleSubscriptionComponent);
		}

		SubmitButtonHelper.performPostSubmitAction(editComponentSelector, {
			actionData: postSubmitActionData,
			shouldForceReloadOnStay: shouldReloadPage
		});
	}
};

module.exports = MySubscriptionsHelper;
